export default {
  toString() {
    return (error) => {
      let text = 'Произошла непредвиденная ошибка, пожалуйста обратитесь в службу техподдержки';

      if (typeof error === 'object' && error.response) {
        if (Object.prototype.hasOwnProperty.call(error.response, 'data')) {
          let objectError;
          if (Object.prototype.hasOwnProperty.call(error.response.data, 'data')) {
            objectError = error.response.data.data;
          } else {
            objectError = error.response.data;
          }

          if (typeof objectError === 'object' && Object.prototype.hasOwnProperty.call(objectError, 'message')) {
            text = objectError.message;
          } else if (typeof objectError === 'object' && Object.prototype.hasOwnProperty.call(objectError, 'detail')) {
            text = objectError.detail;
          } else if (typeof objectError === 'object' && Object.prototype.hasOwnProperty.call(objectError, 'error')) {
            text = objectError.error;
          } else {
            text = objectError;
          }
        } else {
          text = error.response;
        }

        if (Object.prototype.hasOwnProperty.call(text, 'message')) {
          text = text.message;
        }

        if (Object.prototype.hasOwnProperty.call(text, 'detail')) {
          text = text.detail;
        }

        if (Object.prototype.hasOwnProperty.call(text, 'messages')) {
          text = text.messages.join('<br>');
        }
      } else if (typeof error === 'string') {
        text = error;
      }

      return text;
    };
  },
};
